import { hiddenUp } from '@twistopayments/design-system/styles'
import { useAtomValue } from 'jotai'

import type { Navigation } from '@twisto/api-cms'
import { useOpen } from '@twisto/hooks'

import { Modal } from '../modal'
import { navigationThemeAtom } from '../navigation-theme'
import { NestedLinksProvider } from '../nested-links-provider'

import { AuthenticationComponents } from './components/authentication'
import { SecondaryComponents } from './components/secondary-components'
import { Hamburger } from './hamburger'
import * as styles from './secondary-navigation-slot.styles'

type Props = {
  primaryNavigationContent: Navigation['primary']
  secondaryNavigationContent: Navigation['secondary']
  authenticationNavigationContent: Navigation['authentication']
}
const SecondaryNavigationSlot = ({
  primaryNavigationContent,
  secondaryNavigationContent,
  authenticationNavigationContent,
}: Props) => {
  const { isOpen, handleOpen, handleClose } = useOpen()
  const navigationTheme = useAtomValue(navigationThemeAtom)

  return (
    <ul css={styles.secondaryContainer}>
      <SecondaryComponents
        hideOnMobile={true}
        secondaryNavigationContent={secondaryNavigationContent}
      />

      <AuthenticationComponents
        authenticationNavigationContent={authenticationNavigationContent}
        source="main"
      />

      <div css={hiddenUp('lg')}>
        <>
          <Hamburger
            inverted={navigationTheme === 'dark'}
            opened={isOpen}
            onClick={isOpen ? handleClose : handleOpen}
          />
          <NestedLinksProvider>
            <Modal
              authenticationComponents={authenticationNavigationContent}
              opened={isOpen}
              primaryComponents={primaryNavigationContent}
              secondaryComponents={secondaryNavigationContent}
              onClose={handleClose}
            />
          </NestedLinksProvider>
        </>
      </div>
    </ul>
  )
}

export default SecondaryNavigationSlot
